import React from "react";
import styled from "@emotion/styled/macro";
import { withProps } from "recompose";
import arrow from "../../../assets/images/arrow.svg";
import { useTranslation } from "react-i18next";

const CardWrapper = styled.div`
  height: 29em;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 18px 11px rgb(50 81 70 / 4%);
  background: ${({ theme }) => theme.colors.white};
  padding: 2em;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: 2em;
  }
`;
const IconWrapper = styled.div`
  height: 4.125em;
  display: flex;
  align-items: center;
  flex-direction: column;
`;
const TextWrapper = styled.div`
  padding: 2em 0 0 0;
`;
const Subtitle = styled.p`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.primary};
  display: flex;
`;
const Text = styled.p`
  padding: 0.25em 0 0 0;
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.primary};
  line-height: 1.5em;
`;

const Arrow = withProps({ src: arrow })(styled.img`
  margin: 0 0.5em;
`);
const Card = ({ card, icon }) => {
  const { t } = useTranslation();
  return (
    <CardWrapper>
      <IconWrapper>
        <img src={icon} alt={t(`cards.${card}.subtitle`)} />
      </IconWrapper>
      <TextWrapper>
        <Subtitle>
          {t(`cards.${card}.subtitle`)} <Arrow />
        </Subtitle>
        <Text>{t(`cards.${card}.text`)}</Text>
      </TextWrapper>
    </CardWrapper>
  );
};

export default Card;
